<!-- <ara-side-nav class="inside-topnav" *ngIf="routesFlag" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Person On Board</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item active" aria-current="page">{{ 'PERSON-ON-BOARD.POB' | translate }}</li>  -->
            <li class="breadcrumb-item" aria-current="page">
              {{ "PERSON-ON-BOARD.PASS_OVERVIEW" | translate }}
            </li>
            <li class="filter-sort">
              <div
                class="filter-sort-wrapper"
                (clickOutside)="onClickedOutside()"
              >
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li>
                      <h5>{{ "PERSON-ON-BOARD.PASS_STATUS" | translate }}</h5>
                      <p-multiSelect
                        [options]="statusList"
                        [(ngModel)]="selectedStatus"
                      ></p-multiSelect>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>
                          {{
                            "PERSON-ON-BOARD.HAS_IT_BEEN_MADE_COMPLIANT"
                              | translate
                          }}
                        </h5>
                        <p-multiSelect
                          [options]="complientValues"
                          [(ngModel)]="selectedComplients"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "PERSON-ON-BOARD.UNIT" | translate }}</h5>
                        <p-multiSelect
                          [options]="unitList"
                          [(ngModel)]="selectedUnit"
                        ></p-multiSelect>
                        <h5>{{ "PERSON-ON-BOARD.LOCATION" | translate }}</h5>
                        <p-multiSelect
                          [options]="locations"
                          [(ngModel)]="selectedLocation"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>
                          {{ "PERSON-ON-BOARD.PASS_VALIDITY" | translate }}
                        </h5>
                        <p-calendar
                          [showIcon]="true"
                          [showTime]="true"
                          placeholder="From"
                          dateFormat="dd/mm/yy"
                          class="custom-datepicker"
                          readonlyInput="true"
                          [(ngModel)]="selectedFromDate"
                          required
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          showButtonBar="true"
                        >
                        </p-calendar>
                        <p-calendar
                          [showIcon]="true"
                          [showTime]="true"
                          placeholder="To"
                          dateFormat="dd/mm/yy"
                          class="custom-datepicker"
                          readonlyInput="true"
                          [(ngModel)]="selectedToDate"
                          required
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          showButtonBar="true"
                        >
                        </p-calendar>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "PERSON-ON-BOARD.PASS_TYPE" | translate }}</h5>
                        <p-multiSelect
                          [options]="passTypes"
                          [(ngModel)]="selectedPassType"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetValue()"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i>reset
                        </a>
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i>done
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#sort"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-sort"
                    aria-hidden="true"
                    pTooltip="Sort"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul
                    class="filter-section-wrapper sort-section-wrapper collapse"
                    id="sort"
                  >
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>Pass ID</label>
                          <a class="selected">
                            <i
                              (click)="ascPassId()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="">
                            <i
                              (click)="descPassId()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>Submission Date</label>
                          <a class="selected">
                            <i
                              (click)="ascSubmissionDate()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="">
                            <i
                              (click)="descSubmissionDate()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="no-margin-right">
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>Expiry Date</label>
                          <a class="selected">
                            <i
                              (click)="ascExpiryDate()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="">
                            <i
                              (click)="descExpiryDate()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div
              class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10"
            >
              <a
                [ngClass]="
                  passRequestForDataResponse.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="exportToExcel('Export')"
                class="btn btn-primary primary-btn export-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  passRequestForDataResponse.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="downloadZIP()"
                class="btn btn-primary primary-btn export-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
              <!-- <input type="checkbox" [(ngModel)]="IsPassRequestReport" [checked]="IsPassRequestReport"
                (click)="showRequestReport($event)" name="PassRequestOverview">
              <label>{{ 'PERSON-ON-BOARD.SHOW_PASS_REQUEST_REPORT' | translate }}</label> -->
            </div>
            <div
              class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right"
            >
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="table-responsive" *ngIf="isShowPassrequestReport">
            <table align="center" class="table table-bordered">
              <thead>
                <tr>
                  <th>
                    {{
                      "PERSON-ON-BOARD.TOTAL_NO._OF_DELAYED_REQUEST" | translate
                    }}
                  </th>
                  <th>
                    {{
                      "PERSON-ON-BOARD.TOTAL_NO._OF_WAIVED_REQUEST" | translate
                    }}
                  </th>
                  <th>
                    {{
                      "PERSON-ON-BOARD.DELAYED_REQUEST_CONVERTED_INTO_COMPLIANCE"
                        | translate
                    }}
                  </th>
                  <th>
                    {{ "PERSON-ON-BOARD.PENDING_COMPLIANCE" | translate }}
                  </th>
                  <th>
                    {{ "PERSON-ON-BOARD.NON_CONFORMANCES_COUNT" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ passRequestReportData.TotalNumberOfDelayedRequest }}
                  </td>
                  <td>
                    {{ passRequestReportData.TotalNumberOfWaivedRequest }}
                  </td>
                  <td>
                    {{
                      passRequestReportData.DelayedRequestConvertedIntoCompliance
                    }}
                  </td>
                  <td>{{ passRequestReportData.PendingCompliance }}</td>
                  <td>{{ passRequestReportData.NonConformancesCount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15 observation-table">
            <table
              class="table table-bordered table-striped table-condensed fix-tablelayout"
            >
              <thead>
                <tr style="cursor: pointer">
                  <th style="width: 30px">
                    <input
                      type="checkbox"
                      [checked]="isPassRequestsChecked"
                      (change)="selectAllPassRequests($event.target.checked)"
                      [(ngModel)]="isPassRequestsChecked"
                      [value]="isPassRequestsChecked"
                    />
                  </th>
                  <th style="width: 50px">
                    {{ "PERSON-ON-BOARD.PASS_ID" | translate }}
                  </th>
                  <th style="width: 180px">
                    {{ "PERSON-ON-BOARD.FULL_NAME" | translate }}
                  </th>
                  <th style="width: 210px">
                    {{ "MASTERSCREEN.COMPANY_NAME" | translate }}
                  </th>
                  <th style="width: 200px">
                    Contract Holder
                  </th>
                  <th style="width: 200px">
                    Contract Number
                  </th>
                  <th style="width: 180px">
                    {{ "PERSON-ON-BOARD.APPROVAL_STATUS" | translate }}
                  </th>
                  <th style="width: 180px">
                    {{ "PERSON-ON-BOARD.DOCUMENT_STATUS" | translate }}
                  </th>
                  <th style="width: 180px">
                    {{ "PERSON-ON-BOARD.PASS_STATUS" | translate }}
                  </th>
                  <th style="width: 130px">
                    {{ "PERSON-ON-BOARD.EXPIRY_DATE" | translate }}
                  </th>
                  <!-- <th>{{ 'PERSON-ON-BOARD.HAS_IT_BEEN_MADE_COMPLIANT?' | translate }}</th>
									<th>{{ 'PERSON-ON-BOARD.MARKED_AS_NON-CONFORMANCE?' | translate }}</th> -->
                  <th style="width: 130px">
                    {{ "PERSON-ON-BOARD.DOWNLOAD" | translate }}
                  </th>
                  <th style="width: 130px" *ngIf="independentPermissions.SUPER_Admin" >Action</th>
 
                </tr>
              </thead>
              <tbody>
                <tr
                  (contextmenu)="cm.show($event); showContextMenu(passRequest)"
                  #row
                  style="cursor: pointer"
                  *ngFor="
                    let passRequest of passRequestForDataResponse
                      | paginate
                        : {
                            itemsPerPage: itemPerPage,
                            currentPage: pageSize,
                            totalItems: rowCount
                          }
                  "
                  id="{{ passRequest.PassRequestId }}"
                >
                  <td>
                    <input
                      type="checkbox"
                      [(ngModel)]="passRequest.Checked"
                      [checked]="passRequest.Checked"
                      (change)="selectPassRequests(passRequest, $event)"
                      [value]="passRequest"
                    />
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    <span
                      *ngIf="passRequest.PassStatus === 'Draft'"
                      style="color: red"
                      >Draft</span
                    >
                    <span *ngIf="passRequest.PassStatus !== 'Draft'">{{
                      passRequest.PassId
                    }}</span>
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    {{ passRequest.FullName }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    {{ passRequest.CompanyName }}
                  </td>
                  <td
                  (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                  [routerLink]="[
                    '/pob/view-pass-request/',
                    passRequest.PassRequestId
                  ]"
                >
                  {{ passRequest.ContractHolder }}
                </td>
                <td
                (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                [routerLink]="[
                  '/pob/view-pass-request/',
                  passRequest.PassRequestId
                ]"
              >
                {{ passRequest.ContractNumber }}
              </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    {{ passRequest.ApprovalStatus }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    {{ passRequest.DocumentStatus }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    {{ passRequest.PassStatus }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                    [routerLink]="[
                      '/pob/view-pass-request/',
                      passRequest.PassRequestId
                    ]"
                  >
                    <ng-container
                      *ngIf="passRequest.PassTypeName == 'Contractor'"
                      >{{
                        passRequest.PassRequestToDate
                          | dateTimeFormat: "MMM D, YYYY"
                      }}</ng-container
                    >
                    <ng-container *ngIf="passRequest.PassTypeName == 'Staff'"
                      >NA</ng-container
                    >
                  </td>
                  <td (click)="downloadPDF(passRequest.PassRequestId)">
                    <i class="fa fa-download"></i>
                  </td>

                  <td *ngIf="independentPermissions.SUPER_Admin">
                    <ara-record-actions *ngIf="passRequest.PassStatus  === 'Deleted'" [SourceId]="passRequest.PassRequestId" ModuleName="POB" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >
                    </ara-record-actions>
                   </td>
                </tr>
              </tbody>
              <div
                style="width: 500px; margin-top: 15px; color: red"
                *ngIf="!showPagination"
              >
                {{ noRecordsMsg }}
              </div>
              <div style="width: 500px" *ngIf="showPagination">
                <pagination-controls
                  (pageChange)="getServerData($event)"
                ></pagination-controls>
              </div>
            </table>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right"
              ><input
                type="checkbox"
                [checked]="isPassRequestsChecked"
                (change)="selectAllPassRequests($event.target.checked)"
                [(ngModel)]="isPassRequestsChecked"
                [value]="isPassRequestsChecked"
              />Select All</label
            >
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let passRequest of passRequestForDataResponse
                  | paginate
                    : {
                        itemsPerPage: itemPerPage,
                        currentPage: pageSize,
                        totalItems: rowCount
                      }
              "
            >
              <div
                [popover]="passRequest.FullName"
                popoverTitle="Personal Name"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{
                    passRequest.FullName
                  }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="passRequest.Checked"
                      [checked]="passRequest.Checked"
                      (change)="selectPassRequests(passRequest, $event)"
                      [value]="passRequest"
                  /></span>
                </h5>
              </div>
              <p
                class="card-sub-title"
                (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                [routerLink]="[
                  '/pob/view-pass-request/',
                  passRequest.PassRequestId
                ]"
              >
                <span>{{ passRequest.PassId }}</span> -
                <span>{{ passRequest.PassStatus }}</span>
              </p>
              <!-- <p (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                [routerLink]="['/pob/view-pass-request/',passRequest.PassRequestId]">
                <span>{{ passRequest.ContractorOrHSEStatus }}</span> - <span>{{passRequest.HSECheck}}</span>
              </p> -->
              <h5
                (click)="getCurrentDOMElementId(passRequest.PassRequestId)"
                [routerLink]="[
                  '/pob/view-pass-request/',
                  passRequest.PassRequestId
                ]"
              >
                {{ passRequest.IsHasItBeenMadeCompliant }}
              </h5>
            </div>
            <div style="margin-top: 15px; color: red" *ngIf="!showPagination">
              {{ noRecordsMsg }}
            </div>
            <div class="col-sm-12 col-xs-12" *ngIf="showPagination">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (yesClicked)="onYesClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (noClicked)="onNoClickedForConfirmation()"
  (okClicked)="onOkClicked()"
></ara-alerts>
<p-dialog
  header="Pass Request Form"
  [(visible)]="display"
  [modal]="true"
  height="auto"
  width="auto"
>
  <p-header>
    <button
      type="button"
      class="button-cancel"
      pButton
      icon="pi pi-close"
      (click)="display = false"
      label="Close"
      style="float: right"
    ></button>
  </p-header>
  <ara-view-pass-request></ara-view-pass-request>
  <p-footer> </p-footer>
</p-dialog>
<p-contextMenu
  [appendTo]="row"
  [target]="row"
  #cm
  [model]="contextItems"
></p-contextMenu>
